import _ from "lodash";

export enum SearchTypes {
    WEBSITE,
    MOBILE,
    PLAYKEYWORD,
    UNIVERSAL,
    KEYWORD,
    INDUSTRY,
}

type SearchTypesHelperService = {
    standardSearchType(searchType: string): number | undefined;
};

function createSearchTypesHelperService(): SearchTypesHelperService {
    const searchTypeMatch = _.curry((searchType: string, type: string) => {
        return searchType.toLowerCase().indexOf(type.toLowerCase()) > -1;
    });

    // Returns the number in the searchTypes obj
    function standardSearchType(searchType: string): number | undefined {
        const matchesWith = searchTypeMatch(searchType);
        let type: number | undefined;

        if (matchesWith("website")) {
            type = SearchTypes.WEBSITE;
        }

        if (matchesWith("mobile")) {
            type = SearchTypes.MOBILE;
        }

        if (matchesWith("playKeyword")) {
            type = SearchTypes.PLAYKEYWORD;
        }

        if (matchesWith("keyword")) {
            type = SearchTypes.KEYWORD;
        }

        if (matchesWith("industry")) {
            type = SearchTypes.INDUSTRY;
        }

        if (matchesWith("universal")) {
            type = SearchTypes.UNIVERSAL;
        }

        return type;
    }

    return {
        standardSearchType,
    };
}

export default createSearchTypesHelperService();
